<mat-card appearance="outlined">
  @switch (status$ | async) {
    @case ('ready') {
      <mat-card-content>
        <mat-tab-group>
          @for (tab of tabs; track tab) {
            <mat-tab [label]="tab.tabTitle | translate">
              <ng-template matTabContent>
                @if (!tab.tabData.length) {
                  <div class="no-data-placeholder" fxFill fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <mat-icon>notification_important</mat-icon>
                    <h2>{{ 'SHARED.STATISTICS.TOP_ITEMS.NO_DATA_ERROR' | translate }}</h2>
                  </div>
                }
                @if (tab.tabData.length) {
                  <cdk-virtual-scroll-viewport itemSize="170" class="scroll-viewport">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" *cdkVirtualFor="let item of tab.tabData" class="scroll-item">
                      @if (data.hasImages) {
                        <div fxFlex="0 0 200px" class="article-image" >
                          <a [href]="item.url.startsWith('https') ? item.url : 'https://' + item.url" target="_blank" rel="noopener">
                            <img src="{{ item.image }}" [alt]="item.title">
                          </a>
                        </div>
                      }
                      <div fxFlex="auto" class="article-title">
                        <a [href]="item.url.startsWith('https') ? item.url : 'https://' + item.url" target="_blank" rel="noopener">
                          {{ item.title }}
                        </a>
                      </div>
                      <div fxFlex.xs="0 0 75px" fxFlex="0 0 150px" class="article-clicks">{{ item.nbOfClicks | number:'1.0-0':(locale$ | async) }} clics</div>
                      <div fxFlex.xs="0 0 75px" fxFlex="0 0 150px" class="article-displays">{{ item.nbOfDisplays | number:'1.0-0':(locale$ | async) }} affich.</div>
                      <div fxFlex.xs="0 0 30px" fxFlex="0 0 60px" class="article-click-rate">{{ item.clickRate | percent:'1.2-2' }}</div>
                    </div>
                  </cdk-virtual-scroll-viewport>
                }
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      </mat-card-content>
    }
    @case ('loading') {
      <mat-card-content>
        <mat-tab-group>
          <mat-tab>
            <ng-template mat-tab-label>
              <svg xmlns="http://www.w3.org/2000/svg" width="100px" height="50px" preserveAspectRatio="xMidYMid slice">
                <rect x="0" y="10" width="100" height="30" fill="#e5ebee"></rect>
              </svg>
            </ng-template>
            <div class="scroll-viewport loading">
              @for (i of 2 | times; track i) {
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="scroll-item">
                  <div fxFlex="0 0 200px" class="article-image">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                      <rect x="10" y="10" width="180" height="130" fill="#e5ebee"></rect>
                    </svg>
                  </div>
                  <div fxFlex="auto" class="article-title">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="50px" preserveAspectRatio="xMidYMid slice">
                      <rect x="0" y="10" width="100%" height="30" fill="#e5ebee"></rect>
                    </svg>
                  </div>
                  <div fxFlex.xs="0 0 75px" fxFlex="0 0 150px" class="article-clicks">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="50px" preserveAspectRatio="xMidYMid slice">
                      <rect x="0" y="10" width="100%" height="30" fill="#e5ebee"></rect>
                    </svg>
                  </div>
                  <div fxFlex.xs="0 0 75px" fxFlex="0 0 150px" class="article-displays">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="50px" preserveAspectRatio="xMidYMid slice">
                      <rect x="0" y="10" width="100%" height="30" fill="#e5ebee"></rect>
                    </svg>
                  </div>
                  <div fxFlex.xs="0 0 30px" fxFlex="0 0 60px" class="article-click-rate">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="50px" preserveAspectRatio="xMidYMid slice">
                      <rect x="0" y="10" width="100%" height="30" fill="#e5ebee"></rect>
                    </svg>
                  </div>
                </div>
              }
            </div>
          </mat-tab>
          <mat-tab [disabled]="true">
            <ng-template mat-tab-label>
              <svg xmlns="http://www.w3.org/2000/svg" width="100px" height="50px" preserveAspectRatio="xMidYMid slice">
                <rect x="0" y="10" width="100" height="30" fill="#e5ebee"></rect>
              </svg>
            </ng-template>
          </mat-tab>
          <mat-tab [disabled]="true">
            <ng-template mat-tab-label>
              <svg xmlns="http://www.w3.org/2000/svg" width="100px" height="50px" preserveAspectRatio="xMidYMid slice">
                <rect x="0" y="10" width="100" height="30" fill="#e5ebee"></rect>
              </svg>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    }
    @case ('error') {
      <mat-card-content>
        <div id="errorContainer" fxLayout="row" fxLayoutAlign="center center">
          <mat-icon>error</mat-icon>
        </div>
      </mat-card-content>
    }
  }
</mat-card>
